export default {
  setCrawlerSettings(state, settings) {
    state.data.settings = settings.length ? settings : state.data.default;
  },
  sourceDataUpdate(state, { channel, obj }) {
    const settings = state.data.settings;
    state.data.settings = settings.map(s => {
      if (s.channel !== channel) return s;
      s.settings = s.settings.map(item => {
        // eslint-disable-next-line fp/no-mutation
        if (obj.status && item.name !== obj.name) item.status = false;
        if (item.name !== obj.name) return item;
        // eslint-disable-next-line fp/no-mutation
        if (item.status && !obj.status) obj.status = item.status;
        // eslint-disable-next-line no-unused-vars
        const prepare = ({ settings, ...rest }) => ({ ...rest });
        return { ...item, ...prepare(obj) };
      });
      return s;
    });
  }
};
